// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","home__admin":"Home_home__admin__1oGnH"};